import * as React from "react";
const SvgBlueWarning = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width={18} height={18} style={{
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: 2
}} viewBox="0 0 18 18" {...props}><circle cx={9} cy={9} r={9} style={{
    fill: "#3952fa"
  }} /><path d="M10.141 10.421H8.592L8.268 4.22h2.196l-.323 6.201Zm-1.898 2.171c0-.355.095-.624.285-.806.191-.182.468-.273.832-.273.351 0 .622.093.812.279.195.187.292.453.292.8 0 .335-.097.599-.292.794-.194.19-.465.285-.812.285-.356 0-.631-.093-.825-.279-.195-.19-.292-.457-.292-.8Z" style={{
    fill: "#fff",
    fillRule: "nonzero"
  }} /></svg>;
export { SvgBlueWarning as ReactComponent };
export default __webpack_public_path__ + "assets/svg/blue-warningp7NxOMTv7UYktc41.svg";